// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__P34i6","header":"ReportDetails_header__C2Sys","title":"ReportDetails_title__1KyyI","left":"ReportDetails_left__dzfY_"};